import React from "react";
import { MEDFLYT_LOGO_TEXT_ONLY } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";

const ScaffoldLogo = () => {
  return (
    <AppIcon
      icon={MEDFLYT_LOGO_TEXT_ONLY}
      fill="#0A77E6"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        margin: "auto",
      }}
    />
  );
};

export default React.memo(ScaffoldLogo);
